<div class="pagination-controls">
    <button (click)="previousPage()" [disabled]="currentPage === 1">Previous</button>
    <span>Page {{ currentPage }} of {{ totalPages }}</span>
    <button (click)="nextPage()" [disabled]="currentPage === totalPages">Next</button>
  </div>
  